import { render, staticRenderFns } from "./languageCert.vue?vue&type=template&id=b4a903b8&scoped=true&"
import script from "./languageCert.vue?vue&type=script&lang=js&"
export * from "./languageCert.vue?vue&type=script&lang=js&"
import style0 from "./languageCert.vue?vue&type=style&index=0&id=b4a903b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a903b8",
  null
  
)

export default component.exports